import { BaseService } from './BaseService';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import Profile from '@/graphql/queries/Profile.gql';
import OperatorOrganization from '@/graphql/queries/OperatorOrganization.gql';
import OrganizationStaffQuery from '@/graphql/queries/FetchOrganizationStaffs.gql';
import OperatorOrganizationUpdate from '@/graphql/mutations/OperatorOrganizationUpdate.gql';
import {
  loginInit,
  searchOperator,
  CustomerOrganizationScopedInput,
  OperatorOrganizationInput,
  OperatorOrgUpdate,
  organizationStaff,
  PaginationInput,
  updatePassword,
  UpdatePasswordInput
} from '@/types/graphql/schemaTypes';
import initQuery from '@/graphql/queries/LoginInit.gql';
import updatePasswordMutation from '@/graphql/mutations/shipper/UpdatePassword.gql';

class UserService extends BaseService {
  public fetchProfile(): Promise<ApolloQueryResult<searchOperator>> {
    return this.client.query({
      query: Profile
    });
  }

  public fetchOrganization(): Promise<ApolloQueryResult<searchOperator>> {
    return this.client.query({
      query: OperatorOrganization
    });
  }

  public fetchOrganizationStaff(
    organizationArgs?: CustomerOrganizationScopedInput,
    pagination?: PaginationInput | null
  ): Promise<ApolloQueryResult<organizationStaff>> {
    return this.client.query({
      query: OrganizationStaffQuery,
      variables: {
        organizationArgs,
        pagination
      }
    });
  }

  public init(): Promise<ApolloQueryResult<loginInit>> {
    return this.client.query({
      query: initQuery
    });
  }

  public updatePassword(passwordArgs: UpdatePasswordInput): Promise<FetchResult<updatePassword>> {
    return this.client.mutate({
      mutation: updatePasswordMutation,
      variables: { passwordArgs }
    });
  }

  public updateOrganization(operatorOrgArgs: OperatorOrganizationInput):
    Promise<FetchResult<OperatorOrgUpdate>> {
    return this.client.mutate({
      mutation: OperatorOrganizationUpdate,
      variables: { operatorOrgArgs }
    });
  }
}

export const userService = new UserService();
